// wishlist init - Wait for DOM to be ready
$(document).ready(function() {
  initializeWishlistIcons();
});

get_latest_wishlist_records();

// Function to initialize icon states on page load
function initializeWishlistIcons() {
  var wishlistarra = localStorage.getItem("wishlist");
  var array_final = [];
  
  if(wishlistarra == null) {
    var jsonobj = [];
    localStorage.setItem("wishlist", JSON.stringify(jsonobj));
  } else {
    array_final = JSON.parse(wishlistarra);
  }
  
  // Set correct icon state for each product immediately
  $(".wishlist-icons").each(function(){
    var attr_id = $(this).attr("data-handle");
    var find_pro = array_final.includes(attr_id);
    
    if(find_pro == true){
      // Product IS in wishlist - show FILLED icon ONLY
      $(this).find(".unfill-icons").css("display", "none");
      $(this).find(".fill-icons").css("display", "flex");
    }
    else{
      // Product is NOT in wishlist - show UNFILLED icon ONLY
      $(this).find(".fill-icons").css("display", "none");
      $(this).find(".unfill-icons").css("display", "flex");
    }
  });
}

setInterval(function () {
  var tln = $("cart-drawer .cart-drawer__items line-item").length;
  if(tln == 0){
    $(".cart-counter").html('');
  }
  else{
    $(".cart-counter").html(tln);
  }
}, 10);

setTimeout(function(){ 
  $(".wishlist-link").show();  
}, 500);


function get_latest_wishlist_records(){
  setInterval(function () {

    var exln = $("newsletter-popup:visible").length;
    if(exln == 1){
      $("body").addClass("newsletter-overlay"); 
      $(".newsletter-ovr").addClass('active');
    }
    else{
      $("body").removeClass("newsletter-overlay");  
      $(".newsletter-ovr").removeClass('active');
    }
  
    var wishlistarra = localStorage.getItem("wishlist");
    if(wishlistarra == null ){
      var jsonobj = [];
      localStorage.setItem("wishlist", JSON.stringify(jsonobj));
    }
    else
    {
      var array_final = JSON.parse(wishlistarra);
      if(array_final.length == 0){
        // UPDATED: Show unfilled icon when wishlist is empty
        $(".wishlist-app-header-icon .unfill-icons-header-icon svg").show();
        $(".wishlist-app-header-icon .fill-icons-header-icon svg").hide();
        if($(".wishlist-not-exits").length > 0) {
          $(".wishlist-not-exits").show();
          $(".wishlist-exits").hide();
          $(".wishlist-link").show();  
        }
      }
      else{
        // UPDATED: Show filled icon when wishlist has items
        $(".wishlist-app-header-icon .fill-icons-header-icon svg").show();
        $(".wishlist-app-header-icon .unfill-icons-header-icon svg").hide();
        if($(".wishlist-not-exits").length > 0) {
          $(".wishlist-not-exits").hide();
          $(".wishlist-exits").show();
          $(".wishlist-link").show();  
        }
      }

      // UPDATED: Reversed icon logic for individual products
      $(".wishlist-icons").each(function(){
        var attr_id = $(this).attr("data-handle");
        var find_pro = array_final.includes(attr_id);
        if(find_pro == true){
          // Product IS in wishlist - show FILLED icon ONLY
          $(this).find(".unfill-icons").css("display", "none");
          $(this).find(".fill-icons").css("display", "flex");
          $(".wishlist-link").show();  
          $(".wishlist-icons").show(); 
        }
        else{
          // Product is NOT in wishlist - show UNFILLED icon ONLY
          $(this).find(".fill-icons").css("display", "none");
          $(this).find(".unfill-icons").css("display", "flex");
          $(".wishlist-link").show();  
          $(".wishlist-icons").show(); 
        }
      });
    }

    var wishlistarra = localStorage.getItem("wishlist");
    var array_final = JSON.parse(wishlistarra);
    var all_lengths = '';
    for (var i = 0; i < array_final.length; i++) {
      all_lengths += array_final[i]+',';
      $(".wishlist-products .collection__main product-list[data-handle='"+array_final[i]+"']").show();
    }
    if ($("body").hasClass("template-wishlist")) {
      var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?handles='+all_lengths+'';
      window.history.pushState({path:newurl},'',newurl);
    }

    var chk = $("header-search").attr("open");
    if (typeof chk !== 'undefined') {
      $("header-sidebar").css("opacity","0")
    }
    else{
      $("header-sidebar").css("opacity","1")
    }

  }, 500);
}


// UPDATED: When clicking unfilled icon (to ADD to wishlist)
$(document).on("click",".unfill-icons",function(){
  var wishlistarra = localStorage.getItem("wishlist");
  var array_final = JSON.parse(wishlistarra);
  var handle = $(this).parent().attr("data-handle");
  array_final.push(handle);
  localStorage.setItem("wishlist", JSON.stringify(array_final));
  
  // Immediately toggle icons with flex display
  $(this).css("display", "none");
  $(this).siblings(".fill-icons").css("display", "flex");
});

// UPDATED: When clicking filled icon (to REMOVE from wishlist)
$(document).on("click",".fill-icons",function(){
  var wishlistarra = localStorage.getItem("wishlist");
  var array_final = JSON.parse(wishlistarra);
  var handle = $(this).parent().attr("data-handle");
  const index = array_final.indexOf(handle);
  if (index > -1) {
    array_final.splice(index, 1);
  }
  localStorage.setItem("wishlist", JSON.stringify(array_final));
  
  // Immediately toggle icons with flex display
  $(this).css("display", "none");
  $(this).siblings(".unfill-icons").css("display", "flex");
});


$(document).on("click",".remove-wishlist",function(){
  var wishlistarra = localStorage.getItem("wishlist");
  var array_final = JSON.parse(wishlistarra);
  var handle = $(this).parent().attr("data-handle");
  const index = array_final.indexOf(handle);
  if (index > -1) {
    array_final.splice(index, 1);
  }
  $(this).parents(".product-list").remove();
  localStorage.setItem("wishlist", JSON.stringify(array_final));
});


$(document).on("click",".wishlist-link",function(){
  var wishlistarra = localStorage.getItem("wishlist");
  var array_final = JSON.parse(wishlistarra);
  var all_lengths = '';
  for (var i = 0; i < array_final.length; i++) {
    all_lengths += array_final[i]+',';
  }
  window.location.href = '/pages/wishlist?handles='+all_lengths;
});

$(document).on("click",".menu-with-submenu",function(e){
  $(this).parent().toggleClass("active");
  $(this).parent().find(".sub-menu-main").slideToggle(400);
});

$(document).on("click",".main-menu-pa",function(e){
  $(this).toggleClass("active");
  $(this).find(".sub-menu-footer").slideToggle(400);    
});


function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
  results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


$(document).ready(function(){

  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/android/i.test(userAgent)) { 
    $("body").addClass("android");
  }
  else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) { 
    $("body").addClass("ios");
  }
  
  var wishlistarra = localStorage.getItem("red_urls");
  var paths = $("body").attr("path");
  if(wishlistarra != null && paths == 'customers/account' ){
    localStorage.removeItem("red_urls");
    window.location.href = wishlistarra;
  }
  var cust_login = $('.template-login #customer_login').length;
  var foo = getParameterByName('page');
  if(foo != null){
    var urls = '/collections/'+foo ;
    localStorage.setItem("red_urls", urls);
  }

  // Mobile menu
  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  const box = document.querySelector('.marquee-bar-section');

  document.addEventListener('scroll', function () {
    const messageText = isInViewport(box) ? true : false;
    if(messageText == false){
      $("body").addClass("hide-announcement");
    }
    else{
      $("body").removeClass("hide-announcement");
    }
  }, {
    passive: true
  });

});